import { Trans } from '@lingui/macro';

import { Flex, Heading, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import ErrorGlobe from './images/error-globe.svg';

type Props = {
  minHeight?: React.ComponentProps<typeof Flex>['minHeight'];
  mb?: React.ComponentProps<typeof Flex>['mb'];
};

const GeoMapErrorMessage = ({ minHeight = '400px', mb = '6x' }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="2x"
      height="100%"
      minHeight={minHeight}
      px="4x"
      mb={mb}
      backgroundColor={theme.colors.neutral['100']}
    >
      <ErrorGlobe />
      <Heading size="200" textAlign="center" mb="0x">
        <Trans>We had trouble loading the map</Trans>
      </Heading>
      <Text textAlign="center">
        <Trans>Something went wrong. Refresh the page to try again.</Trans>
      </Text>
    </Flex>
  );
};

export default GeoMapErrorMessage;
